import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68dfe8d8")

_pushScopeId("data-v-68dfe8d8")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-sm-12 login-form" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-md-center mb-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 mb-3" }, "Recover Password")
], -1)
const _hoisted_6 = { class: "row justify-content-md-center" }
const _hoisted_7 = { class: "col-lg-8 col-md-10 col-sm-12" }
const _hoisted_8 = { class: "form-group text-left" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-8" }, [
    /*#__PURE__*/_createVNode("button", {
      type: "submit",
      class: "btn btn-block btn-primary form-control"
    }, " Send ")
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["stop","prevent"]))
            }, [
              _createVNode("div", _hoisted_8, [
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.forgotPasswordForm.props.email = $event)),
                  placeholder: "Enter Your Email"
                }, null, 512), [
                  [_vModelText, _ctx.forgotPasswordForm.props.email]
                ]),
                (_ctx.forgotPasswordForm.controls.email.dirty)
                  ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString(_ctx.forgotPasswordForm.controls.email.errorMessage), 1))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_10
            ], 32)
          ])
        ])
      ])
    ]),
    _hoisted_11
  ]))
})